import React, { useState,useRef, useEffect, useContext } from 'react';
import { RefreshContext } from "../RefreshContext";
import CompanyAPI from '../restAPI/CompanyAPI';
import { Layout, Menu, Switch, theme, Typography, Avatar, Dropdown, Badge, Button, Drawer, message, Space, Input, Flex, Select,Tour, Alert, Card, Tooltip  } from 'antd';
import { Outlet, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { logout } from '../redux/slices/authSlice';
import { useNotificationContext } from '../contexts/NotificationContext';
import NotificationManager from '../components/NotificationManager';
import {
  HomeOutlined,
  AppstoreOutlined,
  VideoCameraOutlined,
  FileWordOutlined,
  CoffeeOutlined,
  CalendarOutlined,
  MessageOutlined,
  SettingOutlined,
  LogoutOutlined,
  UserOutlined,
  MoonOutlined,
  BulbOutlined,
  BellOutlined,
  DownOutlined,
  MenuOutlined,
  SunOutlined,
  BankOutlined,
} from '@ant-design/icons';
import Logo from '../assets/logo/logo.svg';
import CompanyLogo from '../assets/logo/companylogo.png';
import AuthRestAPI from '../restAPI/AuthRestAPI';
import { decodeToken } from "react-jwt";
import UserAPI from '../restAPI/UserAPI';


const { Header, Footer, Content } = Layout;
const { Title } = Typography;



const items = [
  {
    label: 'Organization 1',
    key: '1',
    icon: <UserOutlined />,
  },
  {
    label: 'Organization 2',
    key: '2',
    icon: <UserOutlined />,
  },
];

const menuProps = {
  items,
};

function getItem(label, key, icon, children, type, isDisabeld = false) {
  return {
    key,
    icon,
    children,
    label,
    type,
    disabled : isDisabeld 
  };
}

export default function MainLayout({ isDarkMode, toggleTheme, children }) {
const { token } = useSelector(state => state.auth);
//const { refreshKey, companyLogo, setCompanyLogo } = useContext(RefreshContext);
const [open, setOpen] = useState(false);
const ref1 = useRef(null);
const ref2 = useRef(null);
const [radius, setRadius] = useState(8);
  const navigate = useNavigate();
 // const { token } = useSelector(state => state.auth);
  const [groupId, setGroupId] = useState("Select Group");
  const [companyId, setCompanyId] = useState("Select Company");
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [groups, setGroups] = useState([]);
  const [companys, setCompanys] = useState([]);

  // Get global notification status
  const { cancellationStatus, cancellationMessage, isVisible, clearStatus, setProcessingStatus } = useNotificationContext();
  
  // State for notification expansion - start expanded by default
  const [isNotificationExpanded, setIsNotificationExpanded] = useState(true);
  
  // Auto-expand notification when it becomes visible, auto-collapse when dismissed
  useEffect(() => {
    if (isVisible) {
      setIsNotificationExpanded(true); // Show message by default when notification appears
    } else {
      setIsNotificationExpanded(false); // Reset when notification is dismissed
    }
  }, [isVisible]);
  
  
  const [iSGetGroups, setISGetGroups] = useState(true);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedRole, setSelectedRole] = useState();
  const [menuItems, setMenuItems] = useState([]);
  const { refreshKey } = useContext(RefreshContext);
  const dispatch = useDispatch();
  const {
    token: { colorBgLayout, colorPrimary, colorBgContainer },
  } = theme.useToken();

  const [pushNotifications, setPushNotifications] = useState(false);
  const [emailNotifications, setEmailNotifications] = useState(false); // for email notification
  const [emailNotificationsAPIcall, setEmailNotificationsAPIcall] = useState(false); // for email notification API call
  const [profilePicture, setProfilePicture] = useState("");
  const [companyLogo,setCompanyLogo]= useState("");

  const steps = [
   
    {
      title: 'Select Group',
      description: 'Please select the group here.',
      target: () => ref1.current,
      mask: {
        style: {
          //boxShadow: 'inset 0 0 15px #fff',
          backdropFilter: 'grayscale(100%)',
        },
        color: 'rgba(0, 0, 0, 0.60)',
      },
    },
    {
      title: 'Select Company',
      description: 'Please select the company here.',
      target: () => ref2.current,
      mask: {
        style: {
          //boxShadow: 'inset 0 0 15px #fff',
          backdropFilter: 'grayscale(100%)',
        },
        color: 'rgba(0, 0, 0, 0.45)',
      },
    },
  ];

  const handleDrawerOpen = () => {
    setDrawerVisible(true);
  };

  const handleDrawerClose = () => {
    setDrawerVisible(false);
  };

  const decodedTokenValue = decodeToken(token) ||{};
  const roleName = decodedTokenValue.role?.name;

  const handleMenuClick = (e) => {
    if (e.key === 'settings') {
      navigate('/profile'); // Navigate to User Profile
    } else if (e.key === 'company') {
      navigate('/company-profile'); // Navigate to Company Profile
    } else if (e.key === 'logout') {
      localStorage.getItem('groupId');
      localStorage.getItem('companyId');
      localStorage.getItem('token');
      console.log('Logout clicked');
      dispatch(logout()); // Dispatch logout action
      //toggleTheme(false);
      //toggleTheme(false); 
      navigate('/login'); // Navigate to Login
    }
  };

  const onEmailNotoficationChange = (checked)=>
  {
    console.log("email notification",checked);
    setEmailNotifications(checked);
    //call the API for apply the change
     setEmailNotificationMessage(checked);
    //setEmailNotificationsAPIcall(true);

  }
 const setPushNotofication = (checked)=>
 {
  setPushNotifications(checked);
 }
  const preventMenuClose = (e) => {
    e.stopPropagation && e.stopPropagation(); // Ensures we are stopping the DOM event
    e.preventDefault && e.preventDefault(); // Prevent default action if necessary
  };
  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="menu-title" disabled style={{ cursor: 'default', fontWeight: 'bold', fontSize: '16px', padding: '10px 15px', }}>
        Settings
      </Menu.Item>
      <Menu.Divider /> {/* Divider added */}
      <Menu.Item key="push-notifications">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            width: '100%', // Ensure the container spans the full width
          }}
          onClick={(e) => e.stopPropagation()} // Prevent menu close on parent click
        >
          <span style={{ flexGrow: 1, textAlign: 'left', marginRight: '15px' }}>
            Push Notifications
          </span>
          <Switch
            checked={pushNotifications}
            onChange={(checked) => setPushNotifications(checked)}
          />
        </div>
      </Menu.Item>
      <Menu.Item key="email-notifications">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            width: '100%', // Ensure the container spans the full width
          }}
          onClick={(e) => e.stopPropagation()} // Prevent menu close on parent click
        >
          <span style={{ flexGrow: 1, textAlign: 'left', marginRight: '15px' }}>
            Email Notifications
          </span>
          <Switch
            checked={emailNotifications}
            onChange={onEmailNotoficationChange}
          />
        </div>
      </Menu.Item>


      <Menu.Divider />
      <Menu.Item key="settings" icon={<UserOutlined />}>
        User Profile
      </Menu.Item>
      <Menu.Item key="company" icon={<BankOutlined />} disabled={roleName != "Company Admin"}>
        Company Profile
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="logout" icon={<LogoutOutlined />}>
        Logout
      </Menu.Item>
    </Menu>
  );

  //console.log("Menu Item Mapping");
  // console.log(menu);
  /*Object.values(menu).forEach(function (value) {
    // do something with data[key]
    console.log(value);
  });*/

  useEffect(() => {
    //setOpen(true);
    setEmailNotifications(decodedTokenValue.isEmailNotification);
    
  }, []);
  
  /*useEffect(() => {
    if(emailNotificationsAPIcall)
    {
       console.log("inside email API useeffect");
       setEmailNotificationMessage(decodedTokenValue?.userId);
       setEmailNotificationsAPIcall(false);
    }
  }, [emailNotifications,emailNotificationsAPIcall]);*/
 useEffect(()=>{
  console.log("Push notification",pushNotifications);
 },[pushNotifications]);

  useEffect(()=>{
  console.log("Email notification",emailNotifications);
 },[emailNotifications]);

  useEffect(() => {
    getAllGroups();
    const decodedTokenValue = decodeToken(token);
    getProfilePicture(decodedTokenValue.userId);
    console.log("Decoded Token", JSON.stringify(decodedTokenValue));
  }, [refreshKey]);

  useEffect(() => {
    getCompanyProfilePicture();
  }, [refreshKey]);

  useEffect(() => {
    const decodedTokenValue = decodeToken(token);
    setSelectedRole(decodedTokenValue.role.name);
    const role = decodedTokenValue.role.name;

    setMenuItems([]);
    let listPayload = [
      getItem('Dashboard', '/dashboard', <HomeOutlined />),
    ];

    let businessEntityDataList = [];
    let administrationDataList = [];
    let templatesDataList = [];
    let masterDataDataList = [];
    let documentManagementDataList = [];
    let reportsDataList = [];

    const addItem = (list, item) => {
      if (!list.some(existingItem => existingItem.key === item.key)) {
        list.push(item);
      }
    };
    //console.log(role);
    if (role !== null) {
      if (role === "System Admin") {
        addItem(businessEntityDataList, getItem('Groups', '/businessentity/Groups'));
        addItem(businessEntityDataList, getItem('Companies', '/businessentity/Company'));
        addItem(administrationDataList, getItem('Users', '/administration/Users'));
        addItem(templatesDataList, getItem('Templates', '/templates/templates'));
        addItem(masterDataDataList, getItem('Trading Partners', '/masterdata/tradingpartners'));
        addItem(documentManagementDataList, getItem('Accounts Receivable', '/documentupload/AccountReceivable'));
        addItem(documentManagementDataList, getItem('Accounts Payable', '/documentupload/AccountPayable'));
        addItem(reportsDataList, getItem('Document Summary Report', '/reports/DocumentSummaryReport'));
        addItem(reportsDataList, getItem('Total Tax Amount Report', '/reports/TotalTaxAmountReport'));
      } else if (role === "Group Admin") {
        addItem(businessEntityDataList, getItem('Companies', '/businessentity/Company'));
        addItem(administrationDataList, getItem('Users', '/administration/Users'));
        addItem(templatesDataList, getItem('Templates', '/templates/templates',)); //According to priority List No:- 9
        addItem(masterDataDataList, getItem('Trading Partners', '/masterdata/tradingpartners'));
        addItem(documentManagementDataList, getItem('Accounts Receivable', '/documentupload/AccountReceivable'));
        addItem(documentManagementDataList, getItem('Accounts Payable', '/documentupload/AccountPayable'));
        addItem(reportsDataList, getItem('Reports', '/reports/DocumentSummaryReport'));
        addItem(reportsDataList, getItem('Total Tax Amount Report', '/reports/TotalTaxAmountReport'));
      } else if (role === "Company Admin") {
        addItem(businessEntityDataList, getItem('Companies', '/businessentity/Company'));
        addItem(administrationDataList, getItem('Users', '/administration/Users'));
        addItem(templatesDataList, getItem('Templates', '/templates/templates')); //According to priority List No:- 9
        addItem(masterDataDataList, getItem('Trading Partners', '/masterdata/tradingpartners'));
        addItem(documentManagementDataList, getItem('Accounts Receivable', '/documentupload/AccountReceivable'));
        addItem(documentManagementDataList, getItem('Accounts Payable', '/documentupload/AccountPayable'));
        addItem(reportsDataList, getItem('Reports', '/reports/DocumentSummaryReport'));
        addItem(reportsDataList, getItem('Total Tax Amount Report', '/reports/TotalTaxAmountReport'));
      } else if (role === "General User") {
        addItem(templatesDataList, getItem('Templates', '/templates/templates'));// According to priority List No:- 9
        addItem(masterDataDataList, getItem('Trading Partners', '/masterdata/tradingpartners'));
        addItem(documentManagementDataList, getItem('Accounts Receivable', '/documentupload/AccountReceivable'));
        addItem(documentManagementDataList, getItem('Accounts Payable', '/documentupload/AccountPayable'));
        addItem(reportsDataList, getItem('Reports', '/reports/DocumentSummaryReport'));
        addItem(reportsDataList, getItem('Total Tax Amount Report', '/reports/TotalTaxAmountReport'));
      }
    }

    if (businessEntityDataList.length > 0) {
      listPayload.push(
        { type: 'divider' },
        getItem('Business Entity', '', <AppstoreOutlined />, businessEntityDataList),
      );
    }

    if (administrationDataList.length > 0) {
      listPayload.push(
        { type: 'divider' },
        getItem('Administration', '/administration', <SettingOutlined />, administrationDataList),
      );
    }

    if (templatesDataList.length > 0) {
      listPayload.push(
        { type: 'divider' },
        getItem('Templates', '/templates', <SettingOutlined />, templatesDataList,'', checkGroupAndCompanyValues()),
      );
    }

    if (masterDataDataList.length > 0) {
      listPayload.push(
        { type: 'divider' },
        getItem('Master Data', '11', <AppstoreOutlined />, masterDataDataList),
      );
    }

    if (documentManagementDataList.length > 0) {
      listPayload.push(
        { type: 'divider' },
        getItem('Document Management', '/documentupload', <FileWordOutlined />, documentManagementDataList,'',checkGroupAndCompanyValues()),
      );
    }

    if (reportsDataList.length > 0) {
      listPayload.push(
        { type: 'divider' },
        getItem('Reports', '/reports', <CalendarOutlined />, reportsDataList,'',checkGroupAndCompanyValues()),
      );
    }

    listPayload.push(
      getItem('Contact Us', '/contact', <MessageOutlined />),
    );

    setMenuItems(listPayload);
  }, [selectedRole,groupId,companyId]);

  const getAllGroups = async () => {
    await AuthRestAPI.getAllGroups(token, localStorage.getItem('groupId'), localStorage.getItem('companyId')).then((res) => {
      if (res?.data) {
        //console.log(JSON.stringify(res.data));
        //alert(JSON.stringify(res.data));
        const items = [];
        items.push({
          value: "-1",
          label: "All Groups",
        });
        res.data.map((rowValue) => {
          items.push({
            value: rowValue._id,
            label: rowValue.name
          });
        });
        setGroups(items);
        
        // If there's a saved groupId, load companies for that group
        const savedGroupId = localStorage.getItem('groupId');
        if (savedGroupId && savedGroupId !== "Select Group") {
          // Find the group name for the saved groupId
          const savedGroup = res.data.find(group => group._id === savedGroupId);
          if (savedGroup) {
            setGroupId(savedGroup.name);
            getAllCompany(savedGroupId);
          }
        } else {
          setIsDataLoaded(true);
        }
      }
    }).catch(err => {
      console.log("error getting group data :", err.message);
      setIsDataLoaded(true);
    })
  };

  const getProfilePicture = async (userId) => {
    await UserAPI.getProfilePicture(token, localStorage.getItem('groupId'), localStorage.getItem('companyId'), userId).then((res) => {
      if (res?.data) {
        //console.log(JSON.stringify(res.data.profilePicture)); 
        setProfilePicture(res.data.profilePicture);
      }
    }).catch(err => {
      console.log("error getting profile picture data :", err.message);
    })
  };

  const getCompanyProfilePicture = async () => {
    if(localStorage.getItem('companyId')!==null && localStorage.getItem('companyId')!==undefined && localStorage.getItem('companyId')!=="")
    { //setCompanyLogo
        await CompanyAPI.getMyCompany(token, localStorage.getItem('groupId'), localStorage.getItem('companyId')).then((res) => {
          if (res?.data.companyLogo.split("/").pop() !== "undefined" && res?.data.companyLogo.split("/").pop() !== null ) {
            console.log("API Data company profile picture:",JSON.stringify(res.data.companyLogo));
            setCompanyLogo(res.data.companyLogo); 
          }
          else{
            setCompanyLogo();
          }
      }).catch(err => {
          console.log("error getting company data :", err);
      })
    };
  }
  const onGroupSelect = (value) => {
    if (value !== null) {
      setCompanys([]);
      getAllCompany(value);
      
      // Find the group name for the selected value
      const selectedGroup = groups.find(group => group.value === value);
      if (selectedGroup) {
        setGroupId(selectedGroup.label);
      }
      
      setCompanyId("Select Company");
      localStorage.removeItem('groupId');
      localStorage.removeItem('companyId');
      localStorage.setItem('groupId', value);
    }
  }

  const getAllCompany = async (selectedGroupId) => {
    await AuthRestAPI.getAllCompanys(token, selectedGroupId, localStorage.getItem('companyId')).then((res) => {
      if (res?.data) {
        //console.log(JSON.stringify(res.data));
        //alert(JSON.stringify(res.data));
        const items = [];
        res.data.map((rowValue) => {
          items.push({
            value: rowValue._id,
            label: rowValue.name
          });
        });
        setCompanys(items);
        
        // If there's a saved companyId and it's not "Select Company", ensure it's set
        const savedCompanyId = localStorage.getItem('companyId');
        if (savedCompanyId && savedCompanyId !== "Select Company") {
          // Find the company name for the saved companyId
          const savedCompany = res.data.find(company => company._id === savedCompanyId);
          if (savedCompany) {
            setCompanyId(savedCompany.name);
          }
        }
        setIsDataLoaded(true);
      }
    }).catch(err => {
      console.log("error getting company data :", err.message);
      setIsDataLoaded(true);
    })
  };

    const setEmailNotificationMessage = async (checked) => {
    const emailObject = { isEmailNotification:checked }
     console.log("Email API request",JSON.stringify(emailObject)); 
    await UserAPI.setEmailNotificationMessage(token, localStorage.getItem('groupId'), localStorage.getItem('companyId'), emailObject)
    .then((res) => {
      if (res?.data) {
       console.log("Email API responce",JSON.stringify(res)); 
       console.log(res.message);
       //setEmailNotifications(res.data.isEmailNotification);
      }
    }).catch(err => {
      console.log("error setting email notification caused a error :", err.message);
      setEmailNotifications(false);
    })
  };

  const onCompanySelect = (value) => {
    if (value !== null) {
      // Find the company name for the selected value
      const selectedCompany = companys.find(company => company.value === value);
      if (selectedCompany) {
        setCompanyId(selectedCompany.label);
      }
      localStorage.removeItem('companyId');
      localStorage.setItem('companyId', value);
    }
  }

  const checkGroupAndCompanyValues = () =>
  {
    console.log("Call the disabled method");
    console.log("group Id " + groupId);
    console.log("company Id " + companyId);
    let status = true;
    if (groupId !== null && groupId !== undefined && groupId !== 'Select Group') {
       status = false;
    }
    if (companyId !== null && companyId !== undefined && companyId !== 'Select Company') {
      status = false;
    }
    else
    {
      status = true;
    }
    return status;
  }

  return (
    <>
    {/* Global notification manager - persists across page navigation */}
    <NotificationManager />
    
    {/* Global notification status display */}
    {isVisible && (
      <div style={{ 
        position: 'fixed', 
        top: '80px', 
        right: '20px', 
        zIndex: 1000,
        maxWidth: '400px'
      }}>
        {isNotificationExpanded ? (
          <Alert
            message={cancellationMessage}
            type={cancellationStatus === 'processing' ? 'info' : cancellationStatus === 'completed' ? 'success' : 'warning'}
            showIcon
            closable
            onClose={clearStatus}
            style={{ 
              fontSize: '12px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
              cursor: 'pointer'
            }}
            action={
              <Button 
                type="text" 
                size="small" 
                icon={<DownOutlined />}
                onClick={() => setIsNotificationExpanded(false)}
                style={{ padding: '0', minWidth: 'auto' }}
                title="Hide notification"
              />
            }
          />
        ) : (
          <Tooltip title={`Click to show: ${cancellationMessage}`} placement="left">
            <div
              style={{ 
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                borderRadius: '6px',
                border: `1px solid ${cancellationStatus === 'processing' ? '#1890ff' : cancellationStatus === 'completed' ? '#52c41a' : '#faad14'}`,
                cursor: 'pointer',
                width: '36px',
                height: '36px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'white',
                padding: '6px'
              }}
              onClick={() => setIsNotificationExpanded(true)}
            >
              <BellOutlined 
                style={{ 
                  fontSize: '16px',
                  color: cancellationStatus === 'processing' ? '#1890ff' : cancellationStatus === 'completed' ? '#52c41a' : '#faad14'
                }} 
              />
            </div>
          </Tooltip>
        )}
      </div>
    )}
    
    <Layout style={{ minHeight: 'calc(100% - 128px)' }}>
      <Header
        style={{
          backgroundColor: colorBgLayout,
          paddingTop: '15px',
          paddingBottom: '15px',
          height: '90px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Flex align="center" justify="flex-start" gap={24} >
          <Title level={1} className="logotext">
            <span style={{ display: 'flex', alignItems: 'center' }}>
              <img style={{ width: 32, marginTop: -15 }} src={Logo} alt="Logo" /> mogu
            </span>
          </Title>
          <div className='desktop'>
            <div className="combined-dropdown-wrapper" style={{ backgroundColor: colorBgContainer }}>
              {/* 1st Dropdown - Without Arrow */}
              <span  ref={ref1}>
                             <Select
                
                 className="combined-dropdown first-dropdown no-arrow"
                 name="groupDropdown"
                 value={isDataLoaded ? groupId : "Loading..."}
                 //placeholder="Acme Inc."
                 onChange={onGroupSelect}
                 options={groups}
                 suffixIcon={null} // Removes the dropdown arrow
                 dropdownStyle={{
                   minWidth: '180px', // Wider dropdown list
                   padding: '10px', // Optional: padding for aesthetics
                 }}
                 dropdownMatchSelectWidth={false} // Ensures the dropdown width is independent
                 disabled={!isDataLoaded}
               />
              </span>
              <span className="separator">›</span>
              {/* 2nd Dropdown */}
              <span ref={ref2}>
                             <Select
             
                 className="combined-dropdown second-dropdown"
                 name="companyDropdown"
                 value={isDataLoaded ? companyId : "Loading..."}
                 //placeholder="Content API"
                 onChange={onCompanySelect}
                 options={companys}
                 suffixIcon={null}
                 disabled={!isDataLoaded}
               />
              </span>
            </div>
            <img src={companyLogo}  style={{ height: 30, marginLeft: 8, marginTop: 2, }} />
          </div>
        </Flex>
        <div key={refreshKey}>{children}</div>
        <Flex align="center" justify="space-between" gap={24}>
          <div
            onClick={toggleTheme}
            style={{ fontSize: '25px', cursor: 'pointer', color: isDarkMode ? '#ffd700' : '#555' }}
          >
            {isDarkMode ? <SunOutlined /> : <MoonOutlined />}
          </div>
          {/*<span style={{ marginTop: '7px' }}> remove the notification icon
            <Badge count={'5'} offset={[-15, 0]}>
              <BellOutlined style={{ fontSize: '25px', color: isDarkMode ? '#ffd700' : '#555', cursor: 'pointer', marginRight: '10px' }} />
            </Badge>
          </span>*/}
          <Dropdown overlay={()=>(menu)} trigger={['click']} placement="bottomRight">
            <Avatar onClick={(e) => e.preventDefault()}
              style={{ cursor: 'pointer', backgroundColor: colorPrimary, marginTop: '-10px' }}
              //icon={<UserOutlined />} 
              src={profilePicture}
              size="large"
            />
          </Dropdown>
          <span >
            {/* Drawer Menu Toggle */}
            <Button
              className="drawer-toggle"
              type="text"
              icon={<MenuOutlined />}
              style={{ fontSize: 24,marginTop:'-25px' }}
              onClick={handleDrawerOpen}
            />
          </span>
        </Flex>
      </Header>

      {/* Drawer for Mobile Navigation */}
      <Drawer
        title="Menu"
        placement="left"
        onClose={handleDrawerClose}
        visible={drawerVisible}
        bodyStyle={{ padding: 0 }}
      >

        {/* Add the Company Dropdown and Logo to the Drawer */}
        <Flex vertical gap={16} style={{ padding: '16px' }}>
          <img src={CompanyLogo} alt="Company Logo" style={{ height: '30px', width: 'fit-content', marginBottom: 8 }} />
                     <Select
             className="combined-dropdown first-dropdown no-arrow"
             name="groupDropdown"
             value={isDataLoaded ? groupId : "Loading..."}
             onChange={onGroupSelect}
             options={groups}
             suffixIcon={null}
             dropdownStyle={{
               minWidth: '180px',
               padding: '10px',
             }}
             dropdownMatchSelectWidth={false}
             disabled={!isDataLoaded}
           />
                     <Select
             className="combined-dropdown second-dropdown"
             name="companyDropdown"
             value={isDataLoaded ? companyId : "Loading..."}
             onChange={onCompanySelect}
             options={companys}
             suffixIcon={null}
             disabled={!isDataLoaded}
           />

        </Flex>
        <Menu
          mode="inline"

          items={menuItems}
          onClick={({ key }) => {
            navigate(key);
            handleDrawerClose();
          }}
        />
      </Drawer>

      <Header style={{ backgroundColor: colorBgLayout, display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingBottom: 16 }} className='main-menu'>
        <Menu
          mode="horizontal"
          items={menuItems}
          style={{ flex: 1, justifyContent: 'center', borderRadius: 64 }}
          onClick={({ key }) => navigate(key)}
        />
      </Header>

      <Content style={{ backgroundColor: colorBgLayout, paddingLeft: '52px', paddingRight: '52px', minHeight: '85svh' }}>
        <Outlet context={{ isDarkMode, groupId, companyId }} />
        <center style={{ paddingTop: 24, paddingBottom: 24 }}>
          ©{new Date().getFullYear()} metora. All rights reserved.
        </center>
      </Content>
      <Tour
    open={open}
    onClose={() => setOpen(false)}
    steps={steps}
    gap={{
      radius,
    }}
    // mask={{
    //   style: {
    //     boxShadow: 'inset 0 0 15px #333',
    //     filter:' blur(8px)',
    //   },
    //   color: 'rgba(80, 255, 255, .4)',
    // }}
  />
    </Layout>
   
  </>
  );
}
